<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <legend
    class="text-muted"
  >
    {{ 'General'|pgettext('Rental') }}
  </legend>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="4"
    name="name"
    :label="'Name'|pgettext('Rental')"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormInput
      name="name"
      v-model="rental.name"
      required
      autofocus
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="description"
    :label="'Description'|pgettext('Rental')"
    :labelAlign="labelAlign"
  >
    <ItpFormTextarea
      name="description"
      v-model="rental.description"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="company"
    :label="'Company'|pgettext('Rental')"
    :labelAlign="labelAlign"
    required
  >
    <UcCompanySelector
      :item="rental"
      path="company"
      :parameters="b_6917646200545441_parameters"
      required
    >
    </UcCompanySelector>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="site_id"
    :label="'Site'|pgettext('Rental')"
    :labelAlign="labelAlign"
  >
    <UcSiteSelector
      :item="rental"
      path="site"
      :parameters="b_6424600534600827_parameters"
      :initialOptions="[rental.site]"
    >
    </UcSiteSelector>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="categories"
    :label="'Categories'|pgettext('Rental')"
    :labelAlign="labelAlign"
  >
    <ItpFormSelect2
      name="categories"
      multiple
      taggable
      :options="categories"
      v-model="rental.categories"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="location_code"
    :label="'Location'|pgettext('Rental')"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="location_code"
      v-model="rental.location_code"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    name="lot_number"
    :label="'Lot number'|pgettext('Rental')"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="lot_number"
      v-model="rental.lot_number"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    name="house_number"
    :label="'Building number'|pgettext('Rental')"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="house_number"
      v-model="rental.house_number"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    :label="'Area'|pgettext('Rental')"
    :labelAlign="labelAlign"
    contentClass="input-group"
  >
    <ItpFormInput
      type="number"
      name="area"
      v-model="rental.area"
      class="col-8"
    >
    </ItpFormInput>
    <ItpFormSelect
      name="unit_of_area"
      v-model="rental.unit_of_area"
      :options="units"
      class="col-4"
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    :label="'Net floor area'|pgettext('Rental')"
    :labelAlign="labelAlign"
    contentClass="input-group"
  >
    <ItpFormInput
      type="number"
      name="net_floor_area"
      v-model="rental.net_floor_area"
      class="col-8"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    :label="'Net floor area factor'|pgettext('Rental')"
    :labelAlign="labelAlign"
    contentClass="input-group"
  >
    <ItpFormInput
      type="number"
      name="net_floor_area_factor"
      v-model="rental.net_floor_area_factor"
      class="col-8"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <hr>
  </hr>
  <FieldsetRentalValidityData
    :rental="rental"
    :labelAlign="labelAlign"
  >
  </FieldsetRentalValidityData>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetRentalGeneralData extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  rental!: object;

  @Watch('rental')
  onRental(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rental")
  }

  labelAlign!: any;
  units!: any;
  categories!: any;

  async $$load_categories() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'rental' } }).then(data => _.map(data, p => p.name))
  }

  ux!: any;
  b_6917646200545441_parameters!: any;
  b_6424600534600827_parameters!: any;
  dataMembers = ['labelAlign', 'units', 'categories', 'ux', 'b_6917646200545441_parameters', 'b_6424600534600827_parameters'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        units: ["ha"
          ,
          "m2"
          ,
        ]
        ,
        categories: null,
        ux: null,
        b_6917646200545441_parameters: {
          role: "own",
        }
        ,
        b_6424600534600827_parameters: {
          type: "property",
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9376: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9375: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9376 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9375 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9376,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9375],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9376,
      evh_7315092382398562_reload_9375,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("FieldsetRentalGeneralData", FieldsetRentalGeneralData);

</script>